import { hydraUiApi } from '@/services/api';

export type UserFlags = {
  show_denominator_change_release_modal: boolean;
  show_composer_minimap: boolean;
  show_liquid_fallback_modal: boolean;
  save_auto_refresh: boolean;
  aggressive_positivity_available: boolean;
  aggressive_positivity_mode_on: boolean;
  show_segment_json_syntax_support_banner: boolean;
  parcel_editor_on: boolean;
  show_mobile_sdk_required_banner: boolean;
  show_parcel_onboarding_tour: boolean;
  show_parcel_welcome_banner: boolean;
  show_parcel_amp: boolean;
  show_webhook_signing_secret_banner: boolean;
  show_live_language_translation_edit_warning: boolean;
  show_campaign_object_trigger_ui_banner: boolean;
  show_objects_liquid_via_ai: boolean;
  show_chat_sparkles: boolean;
  has_viewed_sample_workspace: boolean;
  survey_analysis_ai: boolean;
  message_suggestions_ai: boolean;
  halloween_stickies_2025_enabled: boolean;
  has_viewed_seg_attr_popover_01: boolean;
  has_viewed_seg_attr_popover_02: boolean;
};

export const postUserFlags = async (
  accountId: number | undefined,
  userId: number | undefined,
  flags: { [key: string]: boolean },
) => {
  await hydraUiApi.users.toggleUserFlags({
    params: { path: { account_id: String(accountId), id: String(userId) } },
    body: flags,
  });
};
